import "./Home.module.css";
import Header from "@/reusable_sections/Header";
import SonicArchitecture from "./sections/SonicArchitecture";
import TheDiscography from "./sections/TheDiscography";
import CareerEchoes from "./sections/CareerEchoes";
import ProductionTiers from "./sections/ProductionTiers";
import ArtistFeedback from "./sections/ArtistFeedback";
import InitiateCollaboration from "./sections/InitiateCollaboration";
import Footer from "@/reusable_sections/Footer";
export default function HomePage() {
  return <div>
      <Header />
      <SonicArchitecture />
      <TheDiscography />
      <CareerEchoes />
      <ProductionTiers />
      <ArtistFeedback />
      <InitiateCollaboration />
      <Footer />
    </div>;
}